import { STORAGE_KEYS } from '@/config'

export const storage = {
  setAccessToken: token => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token)
    }
  },

  getAccessToken: () => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)
    }
    return null
  },

  setRefreshToken: token => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, token)
    }
  },

  getRefreshToken: () => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN)
    }
    return null
  },

  setUser: user => {
    if (typeof window !== 'undefined') {
      // Another person logs in: the previous person's company is not theirs
      // (P4d).
      if (String(storage.getUser()?.id) !== String(user?.id)) {
        sessionStorage.removeItem(STORAGE_KEYS.COMPANY_ID)
        localStorage.removeItem(STORAGE_KEYS.COMPANY_ID)
      }
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user))
    }
  },

  getUser: () => {
    if (typeof window !== 'undefined') {
      const user = localStorage.getItem(STORAGE_KEYS.USER)
      return user ? JSON.parse(user) : null
    }
    return null
  },

  setSubscriptionStatus: value => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEYS.SUBSCRIPTION_STATUS, value)
    }
  },

  getSubscriptionStatus: () => {
    if (typeof window !== 'undefined') {
      return (
        localStorage.getItem(STORAGE_KEYS.SUBSCRIPTION_STATUS) || 'inactive'
      )
    }
    return 'inactive'
  },

  setRequiresSubscription: value => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(
        STORAGE_KEYS.REQUIRES_SUBSCRIPTION,
        JSON.stringify(!!value)
      )
    }
  },

  getRequiresSubscription: () => {
    if (typeof window !== 'undefined') {
      const v = localStorage.getItem(STORAGE_KEYS.REQUIRES_SUBSCRIPTION)
      return v === 'true'
    }
    return false
  },

  setIntendedPlan: value => {
    if (typeof window !== 'undefined') {
      if (value == null || value === '') {
        localStorage.removeItem(STORAGE_KEYS.INTENDED_PLAN)
      } else {
        localStorage.setItem(STORAGE_KEYS.INTENDED_PLAN, value)
      }
    }
  },

  getIntendedPlan: () => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(STORAGE_KEYS.INTENDED_PLAN) || null
    }
    return null
  },

  // The company this tab works in (P4d), a string or null. Each tab keeps
  // its own copy in sessionStorage, so a switch in one tab never moves
  // another; a tab without one starts with the last choice of any tab.
  getCompanyId: () => {
    if (typeof window === 'undefined') return null
    const own = sessionStorage.getItem(STORAGE_KEYS.COMPANY_ID)
    if (own) return own
    const last = localStorage.getItem(STORAGE_KEYS.COMPANY_ID)
    if (last) sessionStorage.setItem(STORAGE_KEYS.COMPANY_ID, last)
    return last
  },

  // The last company chosen in any tab (where new tabs start), or null.
  getRememberedCompanyId: () => {
    if (typeof window === 'undefined') return null
    return localStorage.getItem(STORAGE_KEYS.COMPANY_ID)
  },

  // This tab works in `id`; with `remember`, new tabs start there too.
  setCompanyId: (id, remember = true) => {
    if (typeof window === 'undefined') return
    sessionStorage.setItem(STORAGE_KEYS.COMPANY_ID, String(id))
    if (remember) localStorage.setItem(STORAGE_KEYS.COMPANY_ID, String(id))
  },

  // Forgets `id` after the API refused it, in this tab and as the last
  // choice, wherever it is stored. True when this tab worked in `id`.
  forgetCompanyId: id => {
    if (typeof window === 'undefined' || id == null) return false
    const key = STORAGE_KEYS.COMPANY_ID
    const own = sessionStorage.getItem(key) === String(id)
    if (own) sessionStorage.removeItem(key)
    if (localStorage.getItem(key) === String(id)) localStorage.removeItem(key)
    return own
  },

  clearAuth: () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN)
      localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
      localStorage.removeItem(STORAGE_KEYS.USER)
      localStorage.removeItem(STORAGE_KEYS.SUBSCRIPTION_STATUS)
      localStorage.removeItem(STORAGE_KEYS.REQUIRES_SUBSCRIPTION)
      localStorage.removeItem(STORAGE_KEYS.INTENDED_PLAN)
      localStorage.removeItem(STORAGE_KEYS.COMPANY_ID)
      sessionStorage.removeItem(STORAGE_KEYS.COMPANY_ID)
    }
  },
}
